import type { Notification } from "../../common/types/notificationTypes";

export const filterReadNotifications = (allNotifications: Notification[], unreadNotifications: Notification[]) =>
   allNotifications.filter(
      (notification) => !unreadNotifications.some((unreadNotification) => notification.id === unreadNotification.id)
   );

export const getNotificationsTrackingText = (
   menuItemName: string,
   notificationsCount: number,
   newPromotionArticlesCount: number
) => {
   if (
      (notificationsCount > 0 && menuItemName === "Varslinger") ||
      (newPromotionArticlesCount > 0 && menuItemName === "Kampanjer")
   ) {
      return `${menuItemName} med varsel`;
   }
   return menuItemName;
};
